// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__1nftW","dropdownItem":"style_dropdownItem__nl7Nm","status":"style_status__1feT4","verified":"style_verified__3YlSp","unverified":"style_unverified__2erKK"};